/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_First_NumberInputs */



/**
* | output |
* | --- |
* | "First table number" |
*
* @param {Rooms_First_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_first_number = /** @type {((inputs?: Rooms_First_NumberInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_First_NumberInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Numéro de la première table")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de la primera mesa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Número da primeira mesa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero del primo tavolo")
	return /** @type {LocalizedString} */ ("First table number")
});